export default __webpack_public_path__ + "static/media/logo.20668c84.svg";